var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('vueCanvasNest',{attrs:{"config":{
      color: '127,63,255',
      opactty: 1,
      count: _vm.count,
    },"el":'#bg',"id":"bg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }